import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import HomeMarketingLayout, {
  createHomeAccountUrl
} from '../../components/layout/HomeMarketingLayout';
import './HvaHjelperViDegMed.css';

const BENEFITS = [
  {
    title: 'Vi får deg ut døra',
    text: 'Du slipper å finne ut av alt først. Velg en økt, trykk start og bli med. Det senker terskelen på dager hvor det er lett å utsette.',
    icon: 'fas fa-door-open'
  },
  {
    title: 'Du får en løpevenn på øret',
    text: 'Kanskje løper du alene. Du har ikke nødvendigvis en venn som løper i samme fart eller en gruppe som venter. Med Løpeglad får du selskap på turen. Følelsen kan være: «Kom, vi tar denne sammen.»',
    icon: 'fas fa-headphones'
  },
  {
    title: 'Vi er der når du trenger hjelpen',
    text: 'Råd hjemme i sofaen er én ting. Når pusten blir tung, beina begynner å protestere eller hodet vil gi seg, er hjelpen på øret. Løpeglad kan roe ned, dra litt med eller minne om hva oppgaven er.',
    icon: 'fas fa-hand-holding-heart'
  },
  {
    title: 'Vi avlaster hodet',
    text: 'Du slipper å administrere hele løpeturen: Hvor fort? Hvor lenge? Når skal jeg øke? Burde jeg stoppe? Økten har en plan. Du kan være mer i løpingen og mindre i vurderingen av løpingen.',
    icon: 'fas fa-brain'
  },
  {
    title: 'Musikken gir kroppen takt',
    text: 'Originalmusikken er en del av treningen, ikke bare bakgrunn. Den gir en tydelig frekvens å løpe til og gjør det enklere å kjenne takten i kroppen uten å måtte forstå alt teoretisk først.',
    icon: 'fas fa-music'
  },
  {
    title: 'Du lærer å løpe mens du løper',
    text: 'Korte steg, takt, armbruk, pust, spenning, fart og etter hvert et større steg blir noe du kan erfare i kroppen der og da. Teknikken blir ikke bare informasjon.',
    icon: 'fas fa-shoe-prints'
  },
  {
    title: 'Vi hjelper deg å starte rolig nok',
    text: 'Kanskje løper du for fort fordi du ikke har lært å regulere. Løpeglad kan hjelpe deg å holde igjen før økta blir for tung, og før du må stoppe.',
    icon: 'fas fa-leaf'
  },
  {
    title: 'Vi lærer deg å regulere deg selv',
    text: 'Over tid kan du bli flinkere til å kjenne: Nå går jeg for hardt. Nå kan jeg korte ned steget. Nå kan jeg bli her. Nå har jeg mer å gå på. Målet er ikke bare å følge Elin, men å bli tryggere på egen kropp.',
    icon: 'fas fa-sliders-h'
  },
  {
    title: 'Vi deler opp det som virker stort',
    text: 'En halvtime eller en time kan kjennes uoverkommelig. Drag, pauser, musikk og coaching deler opp turen i små oppgaver. Du trenger ikke klare hele turen på én gang. Du trenger bare å være i det som skjer nå.',
    icon: 'fas fa-stream'
  },
  {
    title: 'Vi hjelper deg gjennom de vanskelige minuttene',
    text: 'Det er lett å være motivert før økta. Verdien viser seg ofte etter 17, 28 eller 43 minutter, når du begynner å forhandle med deg selv. Da er vi fortsatt der med deg.',
    icon: 'fas fa-clock'
  },
  {
    title: 'Vi gir deg progresjon uten at du må være din egen trener',
    text: 'Programmer og økter bygger deg videre over tid. Du slipper å lage planen selv – vi har tenkt progresjonen for deg, så du kan fokusere på å løpe.',
    icon: 'fas fa-chart-line'
  }
];

/* const BREAKS = [
  {
    after: 3,
    image: '/img/running.jpeg',
    caption: 'Coaching når det gjelder som mest – midt i økta.',
    alt: 'Løper i bevegelse'
  },
  {
    after: 7,
    image: '/img/smiling.jpeg',
    caption: 'Mestring bygges steg for steg – ikke på én hard økt.',
    alt: 'Glad løper'
  }
]; */

const HvaHjelperViDegMed = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Hva hjelper vi deg med? | Løpeglad';
  }, []);

  const trialUrl = createHomeAccountUrl();

  return (
    <HomeMarketingLayout>
      <div className="help-page">
      <section className="help-hero">
        <div className="help-hero-bg" aria-hidden="true">
          <img src="/img/hvakanvihjelpdegmed.jpg" alt="" />
        </div>
        <div className="help-hero-scrim" aria-hidden="true" />
        <div className="help-container help-hero-copy">
          <p className="help-eyebrow">Hva hjelper vi deg med?</p>
          <h1>Hva du får hvis du bruker Løpeglad</h1>
          <p className="help-hero-lead">
            Mer enn en plan på papiret – en stemme, en rytme og en trygg struktur
            som følger deg gjennom hele turen.
          </p>
        </div>
      </section>

      <section className="help-intro">
        <div className="help-container help-intro-grid">
          <div>
            <h2>Løping blir enklere når noen er med deg</h2>
            <p>
              Mange vet hva de «burde» gjøre – men det er noe annet å få det til
              når beina er tunge og hodet vil hjem. Løpeglad er laget for akkurat
              de øyeblikkene: før du går ut, mens du løper, og når det blir vanskelig.
            </p>
          </div>
          <aside className="help-intro-aside">
            <img src="/img/elin.png" alt="Elin" />
            <p>
              «Målet er ikke å presse deg hardest mulig. Målet er å bygge trygghet,
              kontinuitet og flyt – steg for steg.»
            </p>
            <span>Elin, coach i Løpeglad</span>
          </aside>
        </div>
      </section>

      <section className="help-benefits">
        <div className="help-container">
          <div className="help-list">
            {BENEFITS.map((benefit, index) => {
              const n = index + 1;
              // const imageBreak = BREAKS.find((b) => b.after === n);
              return (
                <React.Fragment key={benefit.title}>
                  <article className="help-item">
                    <div className="help-item-num" aria-hidden="true">
                      {String(n).padStart(2, '0')}
                    </div>
                    <div className="help-item-body">
                      <div className="help-item-icon" aria-hidden="true">
                        <i className={benefit.icon} />
                      </div>
                      <h3>{benefit.title}</h3>
                      <p>{benefit.text}</p>
                    </div>
                  </article>
                  {/* {imageBreak && (
                    <figure className="help-break">
                      <div className="help-break-frame">
                        <img src={imageBreak.image} alt={imageBreak.alt} />
                        <figcaption>{imageBreak.caption}</figcaption>
                      </div>
                    </figure>
                  )} */}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </section>

      <section className="help-mosaic">
        <div className="help-container help-mosaic-grid">
          <img src="/img/app/home.png" alt="Løpeglad-appen" className="help-mosaic-phone" />
          <div className="help-mosaic-copy">
            <h2>Alt du trenger – i lomma</h2>
            <p>
              Velg økt eller program, trykk start, og få musikk og norsk coaching
              på øret. Ingen ekstra utstyr. Ingen komplisert oppsett.
            </p>
            <ul>
              <li>
                <i className="fas fa-check" aria-hidden="true" />
                Guidede økter med originalmusikk
              </li>
              <li>
                <i className="fas fa-check" aria-hidden="true" />
                Programmer som bygger deg gradvis
              </li>
              <li>
                <i className="fas fa-check" aria-hidden="true" />
                Teknikk, pust og tempo – underveis
              </li>
            </ul>
          </div>
          <img
            src="/img/strength.jpeg"
            alt="Styrketrening"
            className="help-mosaic-side"
          />
        </div>
      </section>

      <section className="help-cta">
        <div className="help-cta-bg" aria-hidden="true">
          <img src="/img/program/bakkestranda1.jpg" alt="" />
        </div>
        <div className="help-container help-cta-inner">
          <h2>Klar for å merke forskjellen?</h2>
          <p>Prøv Løpeglad gratis i 7 dager – og ta med deg en trener på neste tur.</p>
          <div className="help-cta-actions">
            <Link to={trialUrl} className="home-btn home-btn--light">
              Start gratis i 7 dager
            </Link>
            <Link to="/programs" className="help-btn help-btn--ghost-light">
              Se programmer
            </Link>
          </div>
        </div>
      </section>
      </div>
    </HomeMarketingLayout>
  );
};

export default HvaHjelperViDegMed;
